import * as coord from '../../templates';

const buttonStyle =
    'cursor-pointer rounded-lg bg-gray-200 hover:bg-amber-500 hover:text-amber-900 text-gray-500 text-xs uppercase px-4 py-2';

const TemplateSelector = ({ applyTemplate, dbTemplates = [], onDeleteTemplate }) => {
    const templates = [
        { category: 'sticker', label: 'Zapatos', value: 'stickerZapatos' },
        { category: 'sticker', label: 'Redondo', value: 'stickerRedondo' },
        { category: 'sticker', label: 'Redondo2', value: 'stickerRedondo2' },
        { category: 'sticker', label: 'Cuadrado', value: 'stickerCuadrado' },
        { category: 'sticker', label: 'Cuadrado2', value: 'stickerCuadrado2' },
        { category: 'sticker', label: 'Cuaderno', value: 'stickerCuaderno' },
        { category: 'sticker', label: 'Grande', value: 'stickerGrande' },
        { category: 'sticker', label: 'Mediano', value: 'stickerMediano' },
        { category: 'sticker', label: 'Pequeño', value: 'stickerPequeno' },
        { category: 'sticker', label: 'Mini', value: 'stickerMini' },
        { category: 'ropa', label: 'Cuadrada', value: 'ropaCuadrada' },
        { category: 'ropa', label: 'Grande', value: 'ropaGrande' },
        { category: 'ropa', label: 'Pequeña', value: 'ropaPequena' },
        { category: 'ropa', label: 'Redonda', value: 'ropaRedonda' },
        { category: 'combo', label: 'Colegio', value: 'comboColegio' },
        { category: 'combo', label: 'Jardín', value: 'comboJardin' },
        { category: 'combo', label: 'Ropa', value: 'comboRopa' },
        { category: 'combo', label: 'Sticker', value: 'comboSticker' },
    ];

    const selectStaticTemplate = (template) => {
        if (!template) return;
        if (window.confirm(`¿Desea aplicar las coordenadas de la plantilla ${template.category} ${template.label}?`)) {
            let templateCoords = null;
            switch (template.value) {
                case 'stickerZapatos':
                    templateCoords = coord.stickerZapatosTemplate();
                    break;
                case 'stickerRedondo':
                    templateCoords = coord.stickerRedondoTemplate();
                    break;
                case 'stickerRedondo2':
                    templateCoords = coord.stickerRedondo2Template();
                    break;
                case 'stickerCuadrado':
                    templateCoords = coord.stickerCuadradoTemplate();
                    break;
                case 'stickerCuadrado2':
                    templateCoords = coord.stickerCuadrado2Template();
                    break;
                case 'stickerCuaderno':
                    templateCoords = coord.stickerCuadernoTemplate();
                    break;
                case 'stickerGrande':
                    templateCoords = coord.stickerGrandeTemplate();
                    break;
                case 'stickerMediano':
                    templateCoords = coord.stickerMedianoTemplate();
                    break;
                case 'stickerPequeno':
                    templateCoords = coord.stickerPequenoTemplate();
                    break;
                case 'stickerMini':
                    templateCoords = coord.stickerMiniTemplate();
                    break;
                case 'ropaCuadrada':
                    templateCoords = coord.ropaCuadradaTemplate();
                    break;
                case 'ropaGrande':
                    templateCoords = coord.ropaGrandeTemplate();
                    break;
                case 'ropaPequena':
                    templateCoords = coord.ropaPequenaTemplate();
                    break;
                case 'ropaRedonda':
                    templateCoords = coord.ropaRedondaTemplate();
                    break;
                case 'comboColegio':
                    templateCoords = coord.comboColegioTemplate();
                    break;
                case 'comboJardin':
                    templateCoords = coord.comboJardinTemplate();
                    break;
                case 'comboRopa':
                    templateCoords = coord.comboRopaTemplate();
                    break;
                case 'comboSticker':
                    templateCoords = coord.comboStickerTemplate();
                    break;
                default:
                    return false;
            }
            applyTemplate(templateCoords);
        }
    };

    const selectDbTemplate = (t) => {
        if (window.confirm(`¿Desea aplicar la plantilla "${t.name}"?`)) {
            applyTemplate(t.coords);
        }
    };

    return (
        <>
            <h4 className="text-2xl text-gray-600 mt-8 mb-4">Plantillas para coordenadas:</h4>
            <el-tab-group>
                <el-tab-list>
                    <button
                        className="text-lg text-gray-600 mb-4 mr-4 pr-4 border-r border-gray-300 hover:text-orange-700 aria-selected:text-orange-700 cursor-pointer"
                        type="button">
                        Plantillas custom
                    </button>
                    <button
                        className="text-lg text-gray-600 mb-4 hover:text-orange-700 aria-selected:text-orange-700 cursor-pointer"
                        type="button">
                        Plantillas viejas
                    </button>
                </el-tab-list>
                <el-tab-panels>
                    <div>
                        {dbTemplates.length > 0 ? (
                            <>
                                <div className="lg:grid grid-cols-5 gap-2">
                                    {dbTemplates.map((t) => (
                                        <div key={t.id} className="relative">
                                            <button
                                                onClick={() => selectDbTemplate(t)}
                                                className={`${buttonStyle} w-full`}>
                                                <span className="text-2xs block">{t.category}</span>
                                                <span className="font-bold">{t.name}</span>
                                            </button>
                                            <button
                                                onClick={() => onDeleteTemplate(t.id)}
                                                className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-gray-400 hover:bg-red-700 text-white flex items-center justify-center leading-none cursor-pointer"
                                                title="Eliminar plantilla">
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <span className="text-sm text-gray-500">Aún no hay plantillas a medida, puedes crear una, agregando coordenadas y haciendo clic en el botón <strong>Guardar plantilla</strong></span>
                        )}
                    </div>
                    <div hidden>
                        <div className="lg:grid grid-cols-5 gap-2">
                            {templates.map((template) => (
                                <button
                                    key={template.value}
                                    onClick={() => selectStaticTemplate(template)}
                                    className={buttonStyle}>
                                    <span className="text-2xs block">{template.category}</span>
                                    <span className="font-bold">{template.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                </el-tab-panels>
            </el-tab-group>
        </>
    );
};

export default TemplateSelector;
